import getNewRelicInstance from './getNewRelicInstance';
// Capture a page action, useful for 'INFO' or 'WARN' severity logs
// You can query the log in newRelic using NRQL: SELECT count(*) FROM PageAction
const capturePageAction = ({ action, location, severity, statusCode }, attributes)=>{
    const statusCodeMessage = statusCode ? `; statusCode: ${statusCode}` : '';
    const detailedAction = `message: ${action}; location: ${location}; severity: ${severity}${statusCodeMessage}`;
    const nrInstance = getNewRelicInstance();
    nrInstance.addPageAction(detailedAction, attributes);
};
export default capturePageAction;
